import _orderBy from 'lodash/orderBy'
import { useProductionFormatStore } from 'frontcore/store/production-format/useProductionFormatStore'

const unParseProductsAPIResponse = (productionFormatAPIResponse) => {
  return productionFormatAPIResponse.map(productionFormat => {
    return {
      id: productionFormat.id,
      name: productionFormat.name,
      description: productionFormat.description,
      enabled: productionFormat.enabled,
      production_hierarchy: productionFormat.productionHierarchy,
      perimeter: productionFormat.perimeter,
      deletable: productionFormat.deletable,
      updated: productionFormat.updated,
      created: productionFormat.created,
    }
  })
}

const stateObj = {
  productionFormats: [],
}

const getters = {
  getProductionFormats (state) {
    return _orderBy(
      state.productionFormats.filter(item => item.enabled),
      item => item.name.toLowerCase()
    )
  },
  getProductionFormatsWithDisabled (state) {
    return state.productionFormats
  },
  getProductionFormatById: (state) => (id) => {
    return state.productionFormats.find(productionFormat => productionFormat.id === id)
  },
  areProductionFormatsFetchCalled () {
    return useProductionFormatStore().areProductionFormatsCalled
  },
  areProductionFormatsLoaded () {
    return useProductionFormatStore().areProductionFormatsLoaded
  },
}

const mutations = {
  setProductionFormats (state, formats) {
    state.productionFormats = formats
  },
}


const actions = {
  async fetchProductionFormats ({ commit }) {
    await useProductionFormatStore().fetchProductionFormats()
    const unParsedProducts = unParseProductsAPIResponse(useProductionFormatStore().products)
    commit('setProductionFormats', unParsedProducts)
    return unParsedProducts
  },
}

export default {
  actions,
  getters,
  mutations,
  state: stateObj,
}
